<article class="bg-white mt-6 px-4 lg:px-6 py-2.5">
    <div class="justify-between items-start mx-auto max-w-screen-xl">
        
        <div class="grid lg:grid-cols-4 md:grid-cols-2 gap-4 mx-32">
            <div class="lg:mb-0 mb-6">
                <img class="w-full" alt="" src="img/partner/LOGO_FHK_rs-transparent_medium.png" />
            </div>
            <div class="lg:mb-0 mb-6 px-4 -mt-1">
                <img class="w-full" alt="" src="img/partner/Logo_PHSt_quer_farbe.png" />
            </div>
            <div class="lg:mb-0 mb-6 px-6">
                <img class="w-full" alt="" src="img/partner/LOGO_FFG_DE_RGB_1000px.png" />
            </div>
            <div class="lg:mb-0 mb-6 px-3 mt-1">
                <img class="w-full" alt="" src="img/partner/Logo_ISBlang_web_medium.png" />
            </div>
        </div>
    </div>
</article>
